import { Inject, Injectable } from "@angular/core";
import { BehaviorSubject, catchError, Observable, of, tap } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { HttpService } from "./http.service";
import { PlaceDetailsApiResponse, PlacesAutocompleteApiResponse, ReverseGeocodeResponse } from "@sgm-frontend/core";


@Injectable({
  providedIn: 'root'
})
export class GlocationService extends HttpService<any, any> {
//   private mediaListSubject = new BehaviorSubject<MediaData | null>(null);
//   readonly mediaList$ = this.mediaListSubject.asObservable();

  constructor(
    httpClient: HttpClient,
    @Inject('API_URL') apiUrl: string,
    @Inject('API_VERSION') apiVersion: string
  ) {
    super(httpClient, apiUrl, apiVersion, 'google-maps');
  }
getLocations(lat:number,lng:number): Observable<ReverseGeocodeResponse> {
    return this.getAll('/geocode/json?latlng='+lat+','+lng).pipe(catchError((error) => of(error)));
  }
 getSelectedLocation(placeId:string,language:string): Observable<PlaceDetailsApiResponse> {
    return this.getAll('/place/details/json?place_id='+placeId+'&language='+language+'&components=country:AE').pipe(catchError((error) => of(error)));
  }
autoCompleteLocation(searchKey:string,language:string): Observable<PlacesAutocompleteApiResponse> {
    return this.getAll('/place/autocomplete/json?input='+searchKey+'&language='+language+'&components=country:AE').pipe(catchError((error) => of(error)));
  }
}
